<template>
  <div>
    <span class="title">{{ title }}</span>
  </div>
</template>

<script>
import { getters as currentAdvertiserGetter } from '@/vuex/modules/currentAdvertiser/constants'
import IOApi from '@/api/IOApi'
import RouteHelper from '@/mixins/RouteHelper'

export default {
  name: 'OwnerProfileName',
  data() {
    return {
      ioName: '',
    }
  },
  mixins: [RouteHelper],
  async created() {
    if (this.isIOPage) {
      const { items } = await IOApi.fetchIOList({
        advertiserId: parseInt(this.$route.params.advertiserId, 10),
        IOIds: [parseInt(this.$route.params.insertionOrderId, 10)],
        period: 'all',
      })
      this.ioName = items[0].name
    }
  },
  computed: {
    title() {
      if (this.underSystemOwnerPage || this.underAdminPage) {
        return `この地点は広告主全体で利用できます`
      } else if (this.isIOPage) {
        return `この地点は${
          this.ioName
        }のみで利用できます。その他の案件では利用できません。`
      } else {
        const advertiserName = this.$store.getters[
          currentAdvertiserGetter.currentAdvertiserName
        ]
        return `この地点は${advertiserName}広告主のすべての案件で利用できます。`
      }
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  font-size: 12px !important;
}
</style>
